import axios, { AxiosResponse } from 'axios';

/**
 * Получение списка переводов
 */
export const getTranslations = (language: string, name?: string): Promise<AxiosResponse> => {
    return axios.get('/ru/_/service/isnareactcms/helper', {
        params: {
            name,
            action: 'translation',
            language,
        },
    });
};

/**
 * Получение списка сервисов
 */
export const getServicesList = (context: string): Promise<AxiosResponse> => {
    return axios.get('/_/service/isnareactcms/info-services', {
        params: { context },
    });
};

export const sendEmail = (dto: FormData) => {
    return axios.post('/services/isnaportal/api/email/send', dto, {
        headers: {
            'Content-Type': `multipart/form-data; boundary=${dto._boundary}`,
        },
    });
};
